export default __webpack_public_path__ + "ae9a7e7d8591e21c4ebeaf298ec5d896.png";